import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_CUSTOM_FIELDS_DIRECTORY = 'CUSTOM_FIELDS_DIRECTORY';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const customFieldsDirectoryResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_CUSTOM_FIELDS_DIRECTORY,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-custom-fields-directory", jiraSpaEntry: "async-resource-custom-fields-directory" */ './fetchCustomFieldsWithErrorHandling.tsx'
		),
});
